import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { IInforme } from '../../../redux/models/typesInformes';
import TableSortLabel from '@mui/material/TableSortLabel';
import { Order } from '../../../utils/tableUtils';
import { Checkbox, Box } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { hideKeysInforme } from './TablaInformes';

interface TablaInformesProps {
    numSelected: number;
    onRequestSort: (event: React.MouseEvent<unknown>, property: keyof IInforme) => void;
    onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
    order: Order;
    orderBy: string;
    rowCount: number;
    hideColumns?: hideKeysInforme
}

interface HeadCell {
    disablePadding: boolean;
    id: keyof IInforme;
    label: string;
    visible: boolean;
    align: 'left' | 'right' | 'inherit' | 'center' | 'justify' | undefined;

}

export function TablaInformesHead(props: TablaInformesProps) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount,
        onRequestSort, hideColumns = []
    } =
        props;
    const createSortHandler =
        (property: keyof IInforme) => (event: React.MouseEvent<unknown>) => {
            onRequestSort(event, property);
        };

    const headCells: readonly HeadCell[] = [
        {
            id: 'id', align: 'left',
            disablePadding: false, label: '',
            visible: !hideColumns.includes('_id')
        },
        {
            id: 'id', align: 'left',
            disablePadding: false, label: 'ID',
            visible: !hideColumns.includes('id')
        },
        {
            id: 'tipo', align: 'left',
            disablePadding: false, label: 'Tipo',
            visible: !hideColumns.includes('tipo')
        },
        {
            id: 'fechaDeCreacion', align: 'left',
            disablePadding: false, label: 'Fecha',
            visible: !hideColumns.includes('fechaDeCreacion')
        },
        {
            id: 'velocidad', align: 'left',
            disablePadding: false, label: 'Velocidad',
            visible: !hideColumns.includes('velocidad')
        },
        {
            id: 'precio', align: 'left',
            disablePadding: false, label: 'Precio',
            visible: !hideColumns.includes('precio')
        },
        {
            id: 'usuario', align: 'left',
            disablePadding: false, label: 'Usuario',
            visible: !hideColumns.includes('usuario')
        },
        {
            id: 'estadoGeneral', align: 'left',
            disablePadding: false, label: 'Estado',
            visible: !hideColumns.includes('estadoGeneral')
        },

    ];

    return (
        <TableHead>
            <TableRow>
                {/* {
                    !hideColumns.includes('selectable') && (<TableCell padding="checkbox">
                        <Checkbox
                            color="primary"
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={rowCount > 0 && numSelected === rowCount}
                            onChange={onSelectAllClick}
                            inputProps={{
                                'aria-label': 'select all desserts',
                            }}
                        />
                    </TableCell>)
                } */}

                {headCells.map((headCell, index) => headCell.visible && (

                    <TableCell
                        key={`${headCell.id}-${index}`}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            // active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
                {
                    !hideColumns.includes('acciones') && (
                        <TableCell align='center'>
                            ACCIONES
                        </TableCell>
                    )
                }
            </TableRow>
        </TableHead>
    );
}
